<div
    page-header
    text="Request Discount Code"
></div>

<div class="row">
    <div class="col-md-12">
        <div class="well">
            Thank you for participating in the CAEL CE Pretest! Since you completed the CAEL CE Pretest {{regId}}, you are qualified to :
            <ul>
                <li>Receive a $50 discount code which can be used towards a future CAEL CE Test registration. </li>
            </ul>
            Remember, discount codes may only be redeemed on one test registration. Discount codes are non-transferable, not for resale,
            and have no cash value. Your discount code will expire three months from the date of your CAEL CE Pretest sitting.
        </div>
    </div>
</div>

<div
    class="row"
    *ngIf="discountDto"
>
    <div class="col-md-12">
        <div class="form-group">
            <label class="control-label col-md-2">Discount Code:</label> {{discountDto.discountCode}}
        </div>
        <div class="form-group">
            <label class="control-label col-md-2">Expiry Date:</label> {{discountDto.expiryDate | date:'yyyy-MM-dd'}}
        </div>
        <div
            class="form-group"
            *ngIf="discountDto.resultMessage"
        >
            {{discountDto.resultMessage}}
        </div>
        <a
            (click)="gotoMyAccount()"
            class="btn btn-primary"
        >BACK TO MY ACCOUNT</a>
    </div>
</div>
